<script setup>
/* eslint-disable */
import { onMounted, computed, watch, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useFixtureStore } from '@/stores/fixture';
import { useSportUpcomingStore } from '@/stores/sport_upcoming';
import { useCouponsStore } from '@/stores/coupons';

import PreFixtureDoubleMarket from './PreFixtureDoubleMarket.vue';
import LoaderComponent from '@/components/Common/LoaderComponent.vue';

const router = useRouter();
const route = useRoute();

const liveSportsStore = useLiveSportsStore();
const preSportsStore = usePreSportsStore();
const liveSportOverviewStore = useLiveSportOverview();
const fixtureStore = useFixtureStore();
const sportUpcomingStore = useSportUpcomingStore();
const couponsStore = useCouponsStore();

const props = defineProps({
	primary_overview_market: {
		type: Object,
		required: true,
	},
	secondary_overview_market: {
		type: Object,
		required: true,
	},
	sport: {
		type: Object,
		required: false,
	},
	fixtures_count: {
		type: Number,
		default: 5
	}
});

onMounted(() => {
	if (props.sport) {
		let payload = {
		sport_id: props.sport.id,
		hours: 3
	};
		couponsStore.setFixturesLoading(true);
		couponsStore.fetchNextHourFixtures(payload);

		return;
	}

	let payload =  {
		sport_id: router.currentRoute.value.params.sport_id,
		hours: 3
	}

	if (payload.sport_id == '' || payload.sport_id == null) return;

	couponsStore.setFixturesLoading(true);
	couponsStore.fetchNextHourFixtures(payload);
});

watch(() => props.sport, (newSport, oldSportId) => {
	if (newSport.id) {
			let payload = {
			sport_id: newSport.id,
			hours: 3
		};
		couponsStore.setFixturesLoading(true);
		couponsStore.fetchNextHourFixtures(payload);

		return;
	}
});

watch(route, (to, from) => {
	if (to.params.sport_id) {
		let payload =  {
			sport_id: to.params.sport_id,
			hours: 3
		}

		couponsStore.setFixturesLoading(true);
		couponsStore.fetchNextHourFixtures(payload);
	}
});

const competitions = computed(() => {
	if (!props.sport) return couponsStore.nextHourFixturesPerCompetition
	return couponsStore.nextHourFixturesPerCompetition5(props.fixtures_count);
})
</script>

<template>
	<LoaderComponent v-if="couponsStore.fixtures_loading"/>
	<div id="upcoming" class="tab-content" v-else>
		<div v-if="Object.keys(couponsStore.nextHourFixturesPerCompetition).length == 0">
			<div style="margin-top: 20px;">
				<p style="text-align: center; color: white">{{ $t('general.there_are_no_upcoming_events_available') }}</p>
			</div>
		</div>
		<div class="live-info-outer" v-for="(competition, index) in competitions" :key="index">

			<div class="live-info-inner">
				<div class="live-info-team">
					<div class="live-match">
						<div class="team-flag">
							<img :src="'/assets' + competition[0].region_icon_url" alt="">
						</div>
						<div class="live-match-name">
							<h3>{{ competition[0].region_name }} - {{ competition[0].competition_name }}</h3>
						</div>
					</div>
				</div>

				<div class="full-time-top top-title-dash " :class="{'totals_new-grid': primary_overview_market?.market_type == 'totals_new', 'handicap_new_grid': primary_overview_market?.market_type == 'handicap_new'}">
					<span v-if="primary_overview_market?.market_type == 'totals_new' || primary_overview_market?.market_type == 'handicap_new'"/>
					<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
						<span v-if="odd?.length >= 1">{{ odd }}</span>
					</template>
				</div>

				<div class="match-goal-top top-title-dash" :class="{'totals_new-grid': secondary_overview_market?.market_type == 'totals_new', 'handicap_new_grid': secondary_overview_market?.market_type == 'handicap_new'}">
					<span v-if="secondary_overview_market?.market_type == 'totals_new' || secondary_overview_market?.market_type == 'handicap_new'"/>
					<template v-for="(odd, id) in secondary_overview_market?.odd_names" :key="id">
						<span  v-if="odd?.length >= 1">{{ odd }}</span>
					</template>
					<span class="bet-column-empty"></span>

				</div>
			</div>

			<PreFixtureDoubleMarket v-for="(fixture, index) in competition"
				:key="index"
				:primary_overview_market="primary_overview_market"
				:secondary_overview_market="secondary_overview_market"
				:fixture="fixture"
			/>
		</div>
	</div>
</template>
<style scoped>
	:deep(.loading) {
		margin-right: 30px;
		display: flex;
		/* padding-top: 20px; */
		/* margin-left: 40%; */
		height: 100%;
		margin-left: 0px;
		max-height: 100%;
		min-height: 200px;
		justify-content: center;
		/* text-align: center; */
		align-items: center;
		padding-top: 0px;
	}
</style>